export enum EquipmentFunctionalityClass {
    Processing = 10,
    Video = 20,
    IO = 30,
    Ups = 50,
    CommunicationLink = 80,
    CommunicationMaster = 90,
}
